/**
 * Displays the last N runs of the J-1 reminder scheduler cron.
 */
export default function SchedulerHistory({ status }) {
  if (!status?.history || status.history.length === 0) return null;
  return (
    <div className="mb-10 rounded-xl border border-border bg-card p-5" data-testid="scheduler-panel">
      <div className="flex items-center justify-between mb-3">
        <div>
          <div className="text-xs uppercase tracking-[0.25em] text-primary">Scheduler · J-1 reminders</div>
          <div className="text-sm text-muted-foreground mt-1">
            Cron quotidien à {String(status.reminder_hour_utc).padStart(2, "0")}:00 UTC ·
            Prochain : {status.next_run ? new Date(status.next_run).toLocaleString("fr-FR") : "—"}
          </div>
        </div>
      </div>
      <ul className="text-xs text-muted-foreground space-y-1 mt-3">
        {status.history.slice(0, 5).map((h, i) => (
          <li key={`${h.ran_at}-${i}`} className="flex justify-between gap-3 border-t border-border/50 pt-1.5 first:border-0 first:pt-0">
            <span>
              {new Date(h.ran_at).toLocaleString("fr-FR", { dateStyle: "short", timeStyle: "short" })}
              <span className={`ml-2 px-2 py-0.5 rounded text-[10px] uppercase tracking-wider ${h.source === "auto" ? "bg-primary/10 text-primary" : "bg-muted"}`}>
                {h.source}
              </span>
            </span>
            <span>{h.sent} email(s) · {h.events} événement(s)</span>
          </li>
        ))}
      </ul>
    </div>
  );
}
